import {
  ClientFragment,
  ClientsQuery,
  useClientsQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export const useClients = withStandardListHook<
  ClientsQuery,
  ClientFragment,
  'clients'
>(useClientsQuery, 'clients');
